import { ScrollArea, Stack } from "@mantine/core"
import { SectionHeader, Card } from "@tfg/ui"

import { FindOperationChainsResponseDto } from "~/gen/api"
import { OpChainCreation } from "~/pages/Admin/Ingestion/OpChains/components/OpChainList/OpChainCreation"
import { OperationChainListItem } from "~/pages/Admin/Ingestion/OpChains/components/OpChainList/OpChainListItem"
import { OperationChainType } from "~/pages/Admin/Ingestion/OpChains/hooks/useCreateOpChainMutation"

type Props = {
  operationChainType: OperationChainType
  opChains: FindOperationChainsResponseDto[]
}

export function OpChainList({ operationChainType, opChains }: Props) {
  return (
    <Card h="60vh" pos="relative" flex={1}>
      <Stack h="100%" justify="space-between" gap={0}>
        <SectionHeader title={operationChainType} divider h="10%" />
        <Card.Section h="70%">
          <ScrollArea h="100%">
            <Stack align="center">
              {opChains.map((opChain) => {
                return (
                  <OperationChainListItem
                    key={opChain.id}
                    operationChain={opChain}
                  />
                )
              })}
            </Stack>
          </ScrollArea>
        </Card.Section>
        <Card.Section h="10%">
          <OpChainCreation operationChainType={operationChainType} />
        </Card.Section>
      </Stack>
    </Card>
  )
}
